<ng-container *cbWaitFor="lotMappedItem$$ | async">
    @if (!selectedDesignScheme) {
        <cb-design-scheme-search
            [lotMappedItem]="lotMappedItem"
            (designSchemeSelected)="designSchemeSelected($event)"
        >
        </cb-design-scheme-search>
    }
    @if (selectedDesignScheme) {
        <cb-manage-scheme-view
            [mappedItem]="selectedDesignScheme"
            [lotMappedItem]="lotMappedItem"
            (goBack)="handleGoBack()"
        >
        </cb-manage-scheme-view>
    }
</ng-container>
